<template>
<div class="bkg">
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8" v-if="notice">
          <div class="alert alert-warning" role="alert">
            <h4 class="alert-heading">{{notice.title}}</h4>
            <div v-html="notice.body"></div>
          </div>
        </b-col>
        <b-col md="5">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                
                <b-form @submit.prevent="signIn()">
                  <img
                    class="logo-login"
                    :src="getImgUrl(logo)"
                    width="150"
                  >
                  <!-- <h1>Ingresar</h1> -->
                  <p class="text-muted">Ingresa con tu cuenta</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Email" autocomplete="username email" v-model="email"/>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Contraseña" autocomplete="current-password" v-model="password"/>
                  </b-input-group>
                  
                  <b-row>
                    <b-col cols="6">
                      <input type="submit" value="Ingresar" class="btn btn-primary" />
                      <!-- <b-button variant="primary" class="px-4">Ingresar</b-button> -->
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <!-- <b-button variant="link" class="px-0">Forgot password?</b-button> -->
                    </b-col>
                    <b-col cols="12">
                      <span style="color: red;" v-if="alert.message">{{alert.message}}</span>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</div>
</template>

<script>
import api from '@/helpers/api'
import { mapActions, mapGetters } from 'vuex' 
export default {
  name: 'Login',
  data(){
    return {
      email: '',
      password: '',
      company: process.env.VUE_APP_COMPANY,
      notice: null,
      logo: process.env.VUE_APP_LOGO
    }
  },
  computed: {
    ...mapGetters('user', {
      alert: 'error',
      user: 'user'
    })
  },
  mounted(){
    this.$store.dispatch('user/resetUserState')
    api.get('/notice').then(response => {
      this.notice = response.notice
    })
  },
  methods: {
    getImgUrl(logo){
      return require('../../assets/imgs/'+logo)
      // var images = require.context('../img/assets/', false, /\.png$/)
      // return images('./' + logo)
    },
    signIn(){
      let data = {
        email: this.email,
        password: this.password
      }
      this.$store.dispatch('user/login', data)
    }
  }
}
</script>

<style scoped>
.bkg {
  background: #009A3F;
  background-size: cover;
  background-position: center;
}

.logo-login{
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.card-body{
  padding: 0 !important;
}

</style>
